import { Crown } from 'lucide-react';

interface PremiumBadgeProps {
  className?: string;
  onClick?: () => void;
}

export function PremiumBadge({ className = '', onClick }: PremiumBadgeProps) {
  const badge = (
    <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md bg-amber-500/15 text-amber-400 text-[11px] font-semibold ${className}`}>
      <Crown size={10} />
      Premium
    </span>
  );

  if (onClick) {
    return (
      <button onClick={onClick} className="active:scale-95 transition-transform">
        {badge}
      </button>
    );
  }

  return badge;
}
